import { Locale } from "date-fns";
import enUS from "date-fns/locale/en-US";
import ptBR from "date-fns/locale/pt-BR";
import es from "date-fns/locale/es";
import fr from "date-fns/locale/fr";
import it from "date-fns/locale/it";
import zhCN from "date-fns/locale/zh-CN";

const dateFnsLocaleMap: Record<string, Locale> = {
  en: enUS,
  pt: ptBR,
  es,
  fr,
  it,
  zh: zhCN,
};

export const allDateFnsLocales: Record<string, Locale> = {
  "en-US": enUS,
  "pt-BR": ptBR,
  es,
  fr,
  it,
  "zh-CN": zhCN,
};

export function getDateFnsLocale(languagePrefix?: string): Locale {
  return dateFnsLocaleMap[languagePrefix || "en"] || enUS;
}

export function getCalendarCulture(languagePrefix?: string): string {
  const cultureMap: Record<string, string> = {
    en: "en-US",
    pt: "pt-BR",
    es: "es",
    fr: "fr",
    it: "it",
    zh: "zh-CN",
  };
  return cultureMap[languagePrefix || "en"] || "en-US";
}
